import { sendRequest } from "../../sendRequest";

export const rejectOffer = ({ offerId, rejectReason }) => {
  return sendRequest("patch", `/influencer/campaign/offer/reject/${offerId}`, {
    rejectReason,
  }).then((res) => res.data);
};
